

















import Vue from 'vue'
import NoticeBar from '@/components/atoms/NoticeBar.vue'
import TheDrawer from '@/components/organisms/TheDrawer.vue'
export default Vue.extend({
  name: 'TheHeader',
  components: {
    NoticeBar,
    TheDrawer
  },
  data() {
    return {
      isDrawerShown: false
    }
  },
  computed: {
    isLoggedIn(): boolean {
      return this.$state.auth.isLoggedIn
    },
    isNotice(): boolean {
      return this.$state.flash.isNotice
    },
    message(): string {
      return this.$state.flash.message
    },
    isAlert(): boolean {
      return this.$state.flash.isAlert
    }
  },
  watch: {
    isDrawerShown(next) {
      const wrapper: HTMLElement | null = document.querySelector('.rootContainer')
      if (wrapper) {
        if (next) {
          wrapper.style.overflow = 'hidden'
        } else {
          wrapper.style.overflow = 'auto'
        }
      }
    }
  },
  methods: {
    toggleDrawerShown() {
      this.isDrawerShown = !this.isDrawerShown
    },
    closeDrawer() {
      this.isDrawerShown = false
    }
  },
  created() {
    this.$store.dispatch('auth/checkLoggedIn')
  }
})
